"use client"

import * as React from "react"
import * as TabsPrimitive from "@radix-ui/react-tabs"
import { cn } from "@shared/utils"
import type { TabsContentProps } from "../../interfaces/TabsContentProps"

/**
 * @group Components
 * @summary <blockquote>TabsContent component renders the content area for the active tab.</blockquote>
 * @example
 * ```tsx
 * <TabsContent value="tab1" className="custom-tab-content">
 *   <div>Tab 1 content</div>
 * </TabsContent>
 * ```
 */
const TabsContent = React.forwardRef<
  React.ComponentRef<typeof TabsPrimitive.Content>,
  TabsContentProps
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Content
    ref={ref}
    className={cn(
      "mt-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
      className
    )}
    {...props}
  />
))
TabsContent.displayName = TabsPrimitive.Content.displayName

export { TabsContent } 